import { IconButton, Tooltip } from '@material-ui/core';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import BreadCrumb from '../../../component/BreadCrumb';
import { CODE_GROUP_ID } from '../../../constant/Constant';
import CodeUtil from '../../../util/CodeUtil';
import PopupRef from '../../../component/PopupRef';
import ModalRef from '../../../component/ModalRef';
import { modalType } from '../../../util/ModalUtil';
import SelectionBox from '../../../component/SelectionBox';
import DeleteIcon from '../../../component/icon/DeleteIcon';
import RegistButtonBox from '../../../component/buttons/RegistButtonBox';
import TableBox from '../../../component/TableBox';
import { VIEW_SYSTEM_UNIVERSITY } from './../../../constant/ViewConstant';
import SearchButtonBox from '../../../component/buttons/SearchButtonBox';
import NullCheckUtil from '../../../util/NullCheckUtil';
import { defaultGridData, handleControl, initGrid } from '../../../module/component/TableBoxModule';
import { OpenEditIcon } from '../../../component/icon/GridIcons';
import { useLocation } from 'react-router-dom';
import qs from 'qs';
import InputBox from '../../../component/InputBox';
import { actionUniversitySearch, actionUniversityRemove } from '../../../module/body/system/SystemUniversityModule';
import SystemUniversityModal from '../../modal/SystemUniversityModal';

const ConditionArea = ({ popupRef, modalRef }) => {
    const location = useLocation();
    const queryData = qs.parse(location.search, { ignoreQueryPrefix: true });
    const dispatch = useDispatch();

    const [universityCd, setUniversityCd] = useState('');
    const [universityTypeCd, setUniversityTypeCd] = useState('');
    const [universityNm, setUniversityNm] = useState('');
    const [mainUniversityCd, setMainUniversityCd] = useState('');
    const [enrolmentEnableStatusCd, setEnrolmentEnableStatusCd] = useState('');
    const [params, setParams] = useState({});

    const { gridData } = useSelector((state) => state.tableBoxState);

    useEffect(() => {
        dispatch(
            handleControl({
                columns,
                onRowDoubleClick,
                onChangePageInfo,
                params,
            }),
        );

        queryData.universityCd && setUniversityCd(queryData.universityCd);
        queryData.universityTypeCd && setUniversityTypeCd(queryData.universityTypeCd);
        queryData.universityNm && setUniversityNm(queryData.universityNm);
        queryData.mainUniversityCd && setMainUniversityCd(queryData.mainUniversityCd);
        queryData.enrolmentEnableStatusCd && setEnrolmentEnableStatusCd(queryData.enrolmentEnableStatusCd);

        onClickSearch({
            universityCd: queryData.universityCd,
            universityTypeCd: queryData.universityTypeCd,
            universityNm: queryData.universityNm,
            mainUniversityCd: queryData.mainUniversityCd,
            enrolmentEnableStatusCd: queryData.enrolmentEnableStatusCd,
            page: NullCheckUtil.isNotNull(queryData.page) ? queryData.page : defaultGridData.page,
            pageSize: NullCheckUtil.isNotNull(queryData.pageSize) ? queryData.pageSize : 100,
        });

        return () => {
            dispatch(initGrid());
        };
    }, []);

    useEffect(() => {
        dispatch(
            handleControl({
                columns,
                onRowDoubleClick,
                onChangePageInfo,
                params,
            }),
        );
    }, [params]);

    const onChangePageInfo = (page, pageSize) => {
        onClickSearch({
            ...params,
            page,
            pageSize,
        });
    };
    // button action - search
    const onClickSearch = (params) => {
        setParams(params);
        dispatch(
            actionUniversitySearch({
                params,
                callback: (result) => {
                    if (result.totalCount == 0) {
                        popupRef.current.openAlert('조회된 결과가 없습니다.');
                    }
                },
            }),
        );
    };

    const onRowDoubleClick = (row, params) => {
        modalRef.current.open(
            <SystemUniversityModal
                type={modalType.EDIT}
                modalRef={modalRef}
                row={row}
                callback={() => {
                    onClickSearch(params);
                }}
            />,
            'medium',
        );
    };

    const handleDelete = (row, params) => {
        popupRef.current.openWarning('대학 ' + row.universityNm + '(를)을 삭제하시겠습니까?', () => {
            return function () {
                dispatch(
                    actionUniversityRemove({
                        universityCd: row.universityCd,
                        callback: () => {
                            popupRef.current.openInfo(row.universityNm + '(가)이 삭제되었습니다.', () => {
                                return function () {
                                    onClickSearch(params);
                                };
                            });
                        },
                    }),
                );
            };
        });
    };

    const handleAdd = (params) => {
        modalRef.current.open(
            <SystemUniversityModal
                type={modalType.ADD}
                modalRef={modalRef}
                callback={() => {
                    onClickSearch(params);
                }}
            />,
            'medium',
        );
    };

    const onKeyDown = (e) => {
        if (e.key == 'Enter') {
            onClickSearch({
                universityCd,
                universityTypeCd,
                universityNm,
                mainUniversityCd,
                enrolmentEnableStatusCd,
                page: defaultGridData.page,
                pageSize: gridData.pageSize,
            });
        }
    };

    const columns = useMemo(
        () => [
            // {
            //     field: 'sortSeq',
            //     headerName: '순번',
            //     headerAlign: 'center',
            //     align: 'center',
            //     flex: 1,
            //     renderCell: (params) => params.row.sortSeq,
            // },
            {
                field: 'universityNm',
                headerName: '대학명',
                headerAlign: 'center',
                align: 'center',
                flex: 15,
                renderCell: (params) => params.row.universityNm,
            },
            {
                field: 'universityTypeCd',
                headerName: '대학타입',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 8,
                renderCell: (params) =>
                    CodeUtil.getCodeName(CODE_GROUP_ID.UNIVERSITY_TYPE, params.row.universityTypeCd),
            },
            {
                field: 'mainUniversityCd',
                headerName: '주관대학',
                headerAlign: 'center',
                align: 'center',
                flex: 10,
                tooltip: true,
                renderCell: (params) =>
                    CodeUtil.getCodeName(CODE_GROUP_ID.MAIN_UNIVERSITY, params.row.mainUniversityCd),
            },
            {
                field: 'universityEmail',
                headerName: '학교 이메일',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 10,
                renderCell: (params) => params.row.universityEmail,
            },
            {
                field: 'enrolmentEnableStatusCd',
                headerName: '수강신청가능상태',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 8,
                renderCell: (params) =>
                    CodeUtil.getCodeName(CODE_GROUP_ID.ENROLMENT_ENABLE_STATUS, params.row.enrolmentEnableStatusCd),
            },
            {
                field: 'useStatusCd',
                headerName: '학생가입가능상태',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 10,
                renderCell: (params) => CodeUtil.getCodeName(CODE_GROUP_ID.USE_STATUS, params.row.useStatusCd),
            },
            {
                field: 'detail',
                headerName: '기능',
                headerAlign: 'center',
                align: 'center',
                flex: 5,
                disableColumnMenu: true,
                hideSortIcons: true,
                disableExport: true,
                renderCell: (item) => (
                    <>
                        <Tooltip title='수정'>
                            <IconButton onClick={() => onRowDoubleClick(item.row, params)}>
                                <OpenEditIcon />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title={'삭제'}>
                            <IconButton onClick={(e) => handleDelete(item.row, params)}>
                                <DeleteIcon />
                            </IconButton>
                        </Tooltip>
                    </>
                ),
            },
        ],
        [params],
    );

    return (
        <>
            <div className='con-form-wrap '>
                <div className='board-inner'>
                    <div className='board-row'>
                        <div className='lec-check-box'>
                            <div className='search-condition-box'>
                                <div className='form-box-container'>
                                    <SelectionBox
                                        title='대학'
                                        w140
                                        options={CodeUtil.getCodes(CODE_GROUP_ID.USER_UNIVERSITY)}
                                        value={universityCd}
                                        onChange={(e) => setUniversityCd(e.target.value)}
                                        onKeyDown={(e) => onKeyDown(e)}
                                    />
                                    <SelectionBox
                                        title='대학타입'
                                        w140
                                        options={CodeUtil.getCodes(CODE_GROUP_ID.UNIVERSITY_TYPE)}
                                        value={universityTypeCd}
                                        onChange={(e) => setUniversityTypeCd(e.target.value)}
                                        onKeyDown={(e) => onKeyDown(e)}
                                    />
                                    <SelectionBox
                                        title='주관대학'
                                        w140
                                        options={CodeUtil.getCodes(CODE_GROUP_ID.MAIN_UNIVERSITY)}
                                        value={mainUniversityCd}
                                        onChange={(e) => setMainUniversityCd(e.target.value)}
                                        onKeyDown={(e) => onKeyDown(e)}
                                    />
                                    <SelectionBox
                                        title='수강신청가능상태'
                                        w140
                                        options={CodeUtil.getCodes(CODE_GROUP_ID.ENROLMENT_ENABLE_STATUS)}
                                        value={enrolmentEnableStatusCd}
                                        onChange={(e) => setEnrolmentEnableStatusCd(e.target.value)}
                                        onKeyDown={(e) => onKeyDown(e)}
                                    />
                                    <InputBox
                                        title='대학명'
                                        value={universityNm}
                                        onChange={(e) => setUniversityNm(e.target.value)}
                                        onKeyDown={(e) => onKeyDown(e)}
                                    />
                                </div>
                            </div>
                            <div className='lec-check-btn'>
                                <SearchButtonBox
                                    title='조회'
                                    onClick={(e) =>
                                        onClickSearch({
                                            universityCd,
                                            universityTypeCd,
                                            universityNm,
                                            mainUniversityCd,
                                            enrolmentEnableStatusCd,
                                            page: defaultGridData.page,
                                            pageSize: gridData.pageSize,
                                        })
                                    }
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='con-tb-wrap'>
                <div className='con-tb-title  '>
                    <h3 className='tb-tit-name'>참여대학 목록</h3>
                    <RegistButtonBox onClick={(e) => handleAdd(params)} />
                </div>
                <div className='comment-box'>
                    <ul>
                        <li>공동활용대학은 주관대학(COSS 컨소시엄 참여대학)을 설정해 주세요. </li>
                        <li>
                            공동활용대학은 주관대학을 먼저 추가한 뒤 등록해야 합니다. 주관대학(COSS 컨소시엄 참여대학)
                            등록 후 새로고침 하세요.
                        </li>
                        <li>
                            수강신청가능상태를 미사용으로 설정하면 해당 대학의 강의는 수강신청 할 수 없습니다. (수강신청
                            화면에서 해당 대학 강의가 조회되지 않습니다.)
                        </li>
                        <li>
                            학교 이메일에는 메일주소에서 '@' 뒤의 도메인명을 등록하세요. 이메일 등록시 해당 이메일로만
                            학생회원 가입이 가능합니다.
                        </li>
                    </ul>
                </div>
            </div>
        </>
    );
};

const SystemTermView = () => {
    const popupRef = useRef(null);
    const modalRef = useRef(null);

    return (
        <section className='container'>
            <div className='container-inner'>
                <div className='con-title-wrap conbg02'>
                    {/* <h2 className='con-title'>학기 관리</h2> */}
                    <h2 className='con-title'>{VIEW_SYSTEM_UNIVERSITY.title}</h2>
                    <p className='con-title-p'>{VIEW_SYSTEM_UNIVERSITY.subTitle}</p>
                </div>
                <div className='sub-nav-wrap'>
                    <BreadCrumb />
                </div>
                <ConditionArea popupRef={popupRef} modalRef={modalRef} />
                <TableBox isSupportedWide={false} />
            </div>
            <ModalRef ref={modalRef} />
            <PopupRef ref={popupRef} />
        </section>
    );
};

export default SystemTermView;
